import LocalStorage from './storage';
import AnalyticsService, { PageViewData, EventData } from '../services/analytics-service';
import { User } from '../context/auth-context';

export class StoreAnalytics {
  private static sessionId: string | null = null;

  static getOrCreateSessionId(): string {
    if (this.sessionId) {
      return this.sessionId;
    }

    try {
      const stored = localStorage.getItem('store_analytics_session_id');
      if (stored) {
        this.sessionId = stored;
        return stored;
      }
    } catch (error) {
      console.warn('Failed to get session ID from localStorage:', error);
    }

    // Generate new session ID
    this.sessionId = crypto.randomUUID();
    
    try {
      localStorage.setItem('store_analytics_session_id', this.sessionId);
    } catch (error) {
      console.warn('Failed to save session ID to localStorage:', error);
    }

    return this.sessionId;
  }

  static getCurrentStoreSection(): string {
    const path = window.location.pathname;
    
    if (path === '/' || path === '/home') return 'home';
    if (path.startsWith('/shop')) return 'shop';
    if (path.startsWith('/checkout')) return 'checkout';
    if (path.startsWith('/customer')) return 'customer-dashboard';
    if (path.startsWith('/services')) return 'services';
    if (path.startsWith('/help')) return 'help';
    if (path.startsWith('/login')) return 'auth';
    if (path.startsWith('/signup')) return 'auth';
    
    return 'other';
  }

  static getDeviceType(): string {
    const userAgent = navigator.userAgent;
    
    if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
      return 'tablet';
    }
    
    if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(userAgent)) {
      return 'mobile';
    }
    
    return 'desktop';
  }

  static getUtmParameters(): Record<string, string> {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams: Record<string, string> = {};
    
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    
    utmKeys.forEach(key => {
      const value = urlParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });
    
    return utmParams;
  }

  static async getCurrentUser(): Promise<User | null> {
    try {
      return await LocalStorage.getItem<User>('user');
    } catch {
      return null;
    }
  }

  static getUserInfo(user: User | null): { userId?: number; userType: 'guest' | 'customer' } {
    if (user?.id) {
      return {
        userId: user.id,
        userType: 'customer'
      };
    }
    
    return {
      userType: 'guest'
    };
  }
}